// Magic-link auth is a 3-state setting. The API speaks boolean | null
// (true=enabled, false=disabled, null=platform default); the wizard form stores it as a
// string for RadioGroup compatibility. These converters bridge the two representations.
// Kept here (side-effect-free community/utils) so the API mapper can use them without
// importing the page/component tree.
export const MAGIC_LINK_VALUES = ['default', 'enabled', 'disabled'] as const;

export const magicLinkToFormValue = (value: boolean | null | undefined): string => {
  if (value === true) return 'enabled';
  if (value === false) return 'disabled';
  return 'default';
};

export const formValueToMagicLink = (value: string): boolean | null => {
  if (value === 'enabled') return true;
  if (value === 'disabled') return false;
  return null;
};
